<div class="surface-card border-round-xl border-1 border-200 p-4">
  <h3 class="text-lg font-medium text-900 mt-0 mb-1">Billing &amp; Invoicing</h3>
  <p class="text-600 text-sm mt-0 mb-3">
    These settings control this tenant's automated billing behaviour.
  </p>

  <div *ngIf="loading" class="flex flex-column gap-2">
    <p-skeleton height="2rem" styleClass="border-round w-6 mb-2"></p-skeleton>
    <p-skeleton height="4rem" styleClass="border-round"></p-skeleton>
  </div>

  <div *ngIf="!loading" class="formgrid grid">
    <div class="field col-12 md:col-6">
      <label for="billingDayOfMonth" class="block font-medium text-900 mb-2">
        Fixed billing day
      </label>
      <p-inputNumber
        id="billingDayOfMonth"
        [(ngModel)]="billingDayOfMonth"
        [showButtons]="true"
        [min]="1"
        [max]="28"
        placeholder="Anniversary billing"
        styleClass="w-full"
      ></p-inputNumber>
      <small class="text-500">
        Day of the month (1–28) every subscriber on this tenant is billed. Leave
        blank for anniversary-based billing (each subscriber bills on the
        anniversary of their own signup date).
      </small>
    </div>

    <div class="field col-12 md:col-6">
      <label for="billingWindowDays" class="block font-medium text-900 mb-2">
        Invoice lead time (days)
      </label>
      <p-inputNumber
        id="billingWindowDays"
        [(ngModel)]="billingWindowDays"
        [showButtons]="true"
        [min]="1"
        [max]="31"
        styleClass="w-full"
      ></p-inputNumber>
      <small class="text-500">
        How many days before a subscriber's due date their invoice is generated
        and the first payment-due reminder is sent.
      </small>
    </div>

    <div class="field col-12 md:col-6">
      <label for="suspensionGracePeriodDays" class="block font-medium text-900 mb-2">
        Suspension grace period (days)
      </label>
      <p-inputNumber
        id="suspensionGracePeriodDays"
        [(ngModel)]="suspensionGracePeriodDays"
        [showButtons]="true"
        [min]="0"
        [max]="365"
        placeholder="Suspend next day"
        styleClass="w-full"
      ></p-inputNumber>
      <small class="text-500">
        Days a subscription may stay overdue before it's automatically
        suspended. Leave blank to suspend the day after the due date.
      </small>
    </div>

    <div class="field col-12 md:col-6">
      <label for="paymentRetryScheduleDays" class="block font-medium text-900 mb-2">
        Payment retry days
      </label>
      <input
        id="paymentRetryScheduleDays"
        type="text"
        pInputText
        [(ngModel)]="paymentRetryScheduleDaysInput"
        placeholder="1,3,7"
        class="w-full"
      />
      <small class="text-500">
        Comma-separated days after the due date a failed automatic charge is
        re-attempted (e.g. "1,3,7"), stopping once the suspension grace period
        elapses. Only retries a genuine decline, never a payment still
        processing.
      </small>
    </div>
  </div>

  <div *ngIf="!loading" class="flex justify-content-end mt-2">
    <p-button
      label="Save Billing Settings"
      icon="pi pi-check"
      styleClass="p-button-primary"
      [loading]="saving"
      (onClick)="save()"
    ></p-button>
  </div>
</div>
